import React, { Component } from "react";
import Spinner from "../../Utility/Spinner";
import Toaster, { ToasterHelper } from "../../Utility/Toaster";
import { verifySaleOrder } from "../../Utility/URLService";
import { get } from "../../Utility/HttpService";
import { Storage as _storage } from "../../Utility/Storage";
import {
  CartItemKey,
  OrderDetails,
  PassInfoKey,
  RestaurantDetailsByNodeId,
} from "../../Utility/Config";

class ValidateOrder extends Component {
  constructor() {
    super();
    this.state = {
      toaster: [],
      spinner: {
        show: true,
      },
      message: "Please wait your order is being verified",
      orderToken: this.getOrderToken(),
    };
  }
  getOrderToken = () => {
    let token = "";
    if (window.location.search) {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams) {
        token = queryParams.get("token");
      }
    }
    return token;
  };
  componentDidMount() {
    this.checkAndVerifyOrder();
  }
  checkAndVerifyOrder = () => {
    let { orderToken } = this.state;
    if (orderToken) {
      get(`${verifySaleOrder}${orderToken}`)
        .then((result) => result.data)
        .then((data) => {
          this.showSpinner(false);
          if (data.status) {
            var response = JSON.parse(data.data);
            _storage.setItem(
              "temp_" + CartItemKey,
              JSON.stringify(response.CartItems)
            );
            _storage.setItem(
              OrderDetails,
              JSON.stringify(response.OrderDetailsResponse)
            );
            _storage.setItem(
              PassInfoKey,
              JSON.stringify(response.PassInformation)
            );
            _storage.setItem(
              RestaurantDetailsByNodeId,
              JSON.stringify(response.RestaurantDetails)
            );
            this.props.history.push("/orderPlaced");
          } else {
            this.setState({ message: data.message ? data.message : "Link expired or Invalid link" });
            this.showToasterMessage(
              data.message ? data.message : "Invalid Link",
              "e"
            );
          }
        })
        .catch((error) => {
          this.showSpinner(false);
          this.showToasterMessage("Invalid Link", "w");
          this.setState({ message: "Link expired or Invalid link" });
        });
    } else {
      this.showSpinner(false);
      this.showToasterMessage("Invalid Link", "e");
      this.setState({ message: "Link expired or Invalid link" });
    }
  };
  showSpinner = (show) => {
    let { spinner } = this.state;
    spinner.show = show;
    this.setState({ spinner });
  };
  removeToasterMessage = () => {
    this.setState({ toaster: [] });
  };
  showToasterMessage = (message, type, time = 5000) => {
    const toaster = ToasterHelper.show(message, type, time);
    this.setState({ toaster });
  };
  render() {
    let { spinner, toaster, message } = this.state;
    return (
      <div className="p-20">
        <Spinner show={spinner.show} value={spinner}></Spinner>
        {toaster?.length === 1 && (
          <Toaster
            message={toaster[0].message}
            type={toaster[0].type}
            id={toaster[0].id}
            closeCallBack={this.removeToasterMessage}
          />
        )}
        <p className="cen-div">{message}</p>
      </div>
    );
  }
}

export default ValidateOrder;
